import styled, { keyframes, css } from 'styled-components';
import { useThemeContext } from '../../../styles/themes/themes.js';
import { ProgressBarStatus } from '../types.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var CONTAINER_SIZE = 32;
var BAR_THICKNESS = 4;
var StyledContainer = styled.div.withConfig({
  displayName: "Radial__StyledContainer",
  componentId: "sc-fhn2y2-0"
})(["&&{position:relative;height:", "px;width:", "px;}"], CONTAINER_SIZE, CONTAINER_SIZE);
var StyledValueText = styled.div.withConfig({
  displayName: "Radial__StyledValueText",
  componentId: "sc-fhn2y2-1"
})(["&&{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:12px;color:#343a40;}"]);
var indeterminateAnim = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var StyledBar = styled.div.withConfig({
  displayName: "Radial__StyledBar",
  componentId: "sc-fhn2y2-2"
})(["&&{width:100%;height:100%;position:relative;border-radius:50%;display:flex;align-items:center;justify-content:center;background:", ";animation:", ";}&&::before{content:'';position:absolute;height:", "px;width:", "px;border-radius:50%;background-color:white;}"], function (props) {
  return css(["conic-gradient(", " ", "deg,#CFD4DA 0deg)"], props.barBackgroundColor, props.barRadiusLength);
}, function (props) {
  return props.isIndeterminate ? css(["", " 1.5s linear infinite;"], indeterminateAnim) : void 0;
}, CONTAINER_SIZE - BAR_THICKNESS, CONTAINER_SIZE - BAR_THICKNESS);
var Radial = function Radial(props) {
  var status = props.status,
    valuePercentage = props.valuePercentage,
    valueText = props.valueText;
  var theme = useThemeContext();
  var color;
  var radiusLength;
  switch (status) {
    case ProgressBarStatus.error:
      color = theme.alertColors.error;
      radiusLength = 360;
      break;
    case ProgressBarStatus.success:
      color = theme.alertColors.success;
      radiusLength = 360;
      break;
    case ProgressBarStatus.indeterminate:
      color = theme.alertColors.information;
      radiusLength = 90;
      break;
    case ProgressBarStatus.progress:
      color = theme.alertColors.information;
      radiusLength = Math.round(valuePercentage / 100 * 360);
      break;
  }
  return /*#__PURE__*/jsxs(StyledContainer, {
    children: [/*#__PURE__*/jsx(StyledBar, {
      barBackgroundColor: color,
      barRadiusLength: radiusLength,
      isIndeterminate: status === ProgressBarStatus.indeterminate,
      children: "\xA0"
    }), /*#__PURE__*/jsx(StyledValueText, {
      children: valueText
    })]
  });
};
Radial.displayName = "Radial";

export { Radial };
